import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12d9b78a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "modal-container" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k-icon k-i-x" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Branch:")
], -1))
const _hoisted_9 = { class: "col-md-9" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  selected: "",
  value: ""
}, " -- select an option -- ", -1))
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "modal-footer" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Save", -1))
const _hoisted_16 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_notification = _resolveComponent("k-notification")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_k_notification, { ref: "popupNotification" }, null, 512),
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (_ctx.show)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "modal-mask",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.oBackDropClick && _ctx.oBackDropClick(...args)))
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("h3", null, " Bulk Edit Production Branch (" + _toDisplayString(_ctx.orderIds.length) + " " + _toDisplayString(_ctx.orderIds.length > 1 ? "orders" : "order") + ") ", 1),
                    _createElementVNode("div", {
                      class: "close-button",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
                    }, _hoisted_5)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("select", {
                          class: "form-select",
                          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onStatusChange($event)))
                        }, [
                          _hoisted_10,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deliveryBranches, (item) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: item.Id,
                              value: item.Id
                            }, _toDisplayString(item.Name), 9, _hoisted_11))
                          }), 128))
                        ], 32)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _renderSlot(_ctx.$slots, "footer", {}, () => [
                      _createElementVNode("div", null, [
                        _createElementVNode("button", {
                          disabled: _ctx.saving,
                          class: "btn btn-danger",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.close()))
                        }, " Close ", 8, _hoisted_13)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("button", {
                          class: "btn btn-primary",
                          disabled: _ctx.saving || !_ctx.selectedBranchId,
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.saveChanges()))
                        }, [
                          _hoisted_15,
                          (_ctx.saving)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_14)
                      ])
                    ], true)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 64))
}